import { OutsideLayout } from "../components/layout/OutsideLayout";

export const About = () => {
    return (
        <OutsideLayout>
            <div>About Page</div>
        </OutsideLayout>
    );
};
